import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from 'techlify-ng';

const routes: Routes = [
];

export const SlideshowItemRoutingProvider = RouterModule.forRoot(routes, { useHash: true });